<template>
  <div class="min-h-screen flex flex-col bg-white" :style="style">
    <slot name="header" />

    <main
      class="flex-1 w-full relative"
      :class="{ 'max-w-7xl m-auto pt-6 pb-20 px-4 sm:px-6 lg:px-8': contained }"
    >
      <slot />
    </main>

    <slot name="footer">
      <DefaultFooter v-show="!flags.iframe_mode" />
    </slot>

    <CreditsDeeplink />
  </div>
</template>

<script>
import CreditsDeeplink from '@/components/credits/CreditsDeeplink'
import DefaultFooter from '@/components/DefaultFooter'
import { mapState } from 'vuex'
import { Events, EventBus } from '~/lib/events'

export default {
  components: { DefaultFooter, CreditsDeeplink },

  props: {
    contained: { type: Boolean, default: true },
  },

  computed: {
    style() {
      return {
        '--color-enterprise-primary': this.enterprise.theme.palette.primary,
        '--color-enterprise-secondary': this.enterprise.theme.palette.secondary,
      }
    },

    ...mapState(['enterprise', 'flags']),
  },

  mounted() {
    EventBus.$emit(Events.LayoutMounted)
  },
}
</script>
